import { Grid } from '@mui/material';
import { Fragment, useState } from 'react';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import FiscalYeaCreateView from '../../../components/account/setup/fiscal_year/FiscalYeaCreateView';
import FiscalYearListView from '../../../components/account/setup/fiscal_year/FiscalYearListView';
import TariffParameterCreateView from '../../../components/account/setup/tariff_parameter/TariffParameterCreateView';
import TariffParameterListView from '../../../components/account/setup/tariff_parameter/TariffParameterListView';

const TariffParameterCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.AccountURL + 'account/unit/rate/create/list/view/');

    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };
    const { data:tap_list, loading:tap_loading, error:tap_errr, refetch:tap_refresh } = useFetchData(AppURL.AccountURL+"account/tap/size/options/list/view/");

   
  return (
      <Fragment>
          <Grid container spacing={3}>
              <Grid item xl={3} md={4} sm={12} xs={12} lg={3}>
                  <TariffParameterCreateView tap_loading={tap_loading} tap_list={tap_list} handleFormSuccess={handleFormSuccess} />
              </Grid>
              <Grid item xl={9} md={8} sm={12} xs={12} lg={9}>
                  <TariffParameterListView tap_loading={tap_loading} tap_list={tap_list} handleFormSuccess={handleFormSuccess} setOnURL={setOnURL} results={data} error={error} loading={loading} />
              </Grid>
          </Grid>
      </Fragment>
  )
}

export default TariffParameterCreateListView